import { ID } from "@datassential/platform-ui-lib";

export interface IOption<I = ID, T = string> {
    id: I;
    title: T;
}

export enum Sort {
    Asc = 'asc',
    Desc = 'desc',
}

export enum Feedback {
    None = '',
    Up = 'up',
    Down = 'down',
}